// extracted by mini-css-extract-plugin
module.exports = {"selectLabel":"TradingCHero_selectLabel__Uf00J","selectInput":"TradingCHero_selectInput__G5QsT","title":"TradingCHero_title__M5A8F"};